/**
 * Infos cours — Petits Samouraïs (page publique /infos-petits-samourais)
 * Texte fixe FR/EN fourni par Kru (nouvelle formule du cours mardi/jeudi).
 */
import { useState } from "react";
import PublicContactSection from "../components/PublicContactSection";

export default function PetitsSamouraisInfo() {
  const [lang, setLang] = useState("fr");

  return (
    <div className="min-h-screen bg-zinc-950 text-white" data-testid="petits-samourais-info">
      <div className="border-b border-zinc-900 bg-gradient-to-b from-zinc-900 to-zinc-950">
        <div className="max-w-3xl mx-auto px-6 py-14 text-center">
          <div className="text-5xl mb-3">🥋</div>
          <div className="text-amber-400 text-xs tracking-[0.3em] uppercase mb-2">Institut Impact Élite Martial</div>
          <h1 className="text-3xl sm:text-4xl font-bold">
            {lang === "fr" ? "Cours Petits Samouraïs — Nouvelle formule" : "Little Samurais Class — New Format"}
          </h1>
          <div className="flex justify-center gap-2 mt-6">
            <button onClick={() => setLang("fr")} className={`px-4 py-1.5 rounded-full text-sm ${lang === "fr" ? "bg-amber-600 text-white" : "bg-zinc-800 text-zinc-400"}`} data-testid="lang-fr-btn">Français</button>
            <button onClick={() => setLang("en")} className={`px-4 py-1.5 rounded-full text-sm ${lang === "en" ? "bg-amber-600 text-white" : "bg-zinc-800 text-zinc-400"}`} data-testid="lang-en-btn">English</button>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-10">
        <div className="rounded-xl border border-red-500/40 bg-red-500/10 p-5 mb-6 text-center" data-testid="samourais-info-rentree">
          <div className="text-3xl mb-1">🗓️</div>
          <div className="text-red-200 font-bold text-lg">
            {lang === "fr" ? "Rentrée : Mercredi 9 septembre 2026" : "New season starts: Wednesday, September 9, 2026"}
          </div>
          <div className="text-xs text-zinc-400 mt-1">
            {lang === "fr" ? "Petits Samouraïs Parents-Enfants (3-6 ans) — places limitées" : "Little Samurais Parent-Child (ages 3-6) — limited spots"}
          </div>
        </div>
        {lang === "fr" ? <FR /> : <EN />}

        <div className="mt-10 bg-zinc-900 border border-zinc-800 rounded-xl p-5 text-center">
          <p className="text-zinc-300 text-sm mb-3">
            {lang === "fr" ? "Une question sur la transition ?" : "Questions about the transition?"}
          </p>
          <a href="tel:+18195279446" className="inline-block px-5 py-2.5 rounded-lg bg-amber-600 hover:bg-amber-500 text-white text-sm font-semibold">
            {lang === "fr" ? "Nous contacter · 819-527-9446" : "Contact us · 819-527-9446"}
          </a>
        </div>
      </div>
    </div>
  );
}

function Card({ title, children }) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-5 mb-5">
      {title && <h2 className="text-amber-300 font-semibold mb-2">{title}</h2>}
      {children}
    </div>
  );
}

function FR() {
  return (
    <div>
      <p className="text-zinc-300 leading-relaxed mb-5">
        Le cours <strong className="text-white">Petits Samouraïs</strong> du mardi et jeudi évolue pour offrir une base encore plus solide à vos enfants.
      </p>
      <Card title="Autodéfense – Jiu-jitsu Can Ryu — Enfants & parents (3 à 5 ans)">
        <ul className="text-zinc-300 text-sm space-y-1.5 list-disc list-inside">
          <li>Activité ludique et encadrée pour les tout-petits.</li>
          <li>Participation active des parents sur le tatami.</li>
          <li>Introduction à l'autodéfense, au jiu-jitsu, au contrôle au sol et à la sécurité.</li>
          <li>Mises en situation adaptées à l'âge, dans un cadre positif et sécuritaire.</li>
        </ul>
      </Card>
      <Card title="Enfants de 6 ans et plus">
        <p className="text-zinc-300 text-sm">
          Dirigés progressivement vers le <strong className="text-white">programme Junior dès septembre</strong>. L'été (juillet-août) est une période de transition douce (petits groupes, plus d'attention).
        </p>
      </Card>
      <Card title="Été (juillet-août)">
        <p className="text-zinc-300 text-sm">
          Pas de cours sur ce créneau ; contrats fermés pour l'été ; reprise en septembre avec le nouveau format ; option : transférer l'enfant dans un groupe Junior. Pour toute question, contactez-nous.
        </p>
      </Card>
    </div>
  );
}

function EN() {
  return (
    <div>
      <p className="text-zinc-300 leading-relaxed mb-5">
        The <strong className="text-white">Little Samurais</strong> class on Tuesday and Thursday is evolving to offer an even stronger base for your children.
      </p>
      <Card title="Self-defense – Jiu-jitsu Can Ryu — Kids & parents (3–5 years old)">
        <ul className="text-zinc-300 text-sm space-y-1.5 list-disc list-inside">
          <li>Fun, structured activity for very young children.</li>
          <li>Parents welcome on the tatami.</li>
          <li>Introduction to self-defense, jiu-jitsu, ground control and safety.</li>
          <li>Age-appropriate drills and games in a safe, positive environment.</li>
        </ul>
      </Card>
      <Card title="Children 6+">
        <p className="text-zinc-300 text-sm">
          Gradually move into the <strong className="text-white">Junior program in September</strong>. Summer (July–August) is a smooth transition period (smaller groups, more attention).
        </p>
      </Card>
      <Card title="Summer (July–August)">
        <p className="text-zinc-300 text-sm">
          No class on this slot; contracts closed for summer; fresh restart in September; option to move the child into a Junior group. Questions? Contact us.
        </p>
      </Card>
      <PublicContactSection source="petits_samourais" title="Une question sur les Petits Samouraïs ?" subtitle="Horaire, inscription, essai — écris-nous et on te répond vite." />
    </div>
  );
}
